import { getAuthHeaders } from 'ui/screens/SignIn/helpers'
import { callApi } from 'domains/common/callApi'

const getBaseUrl = () => {
  const { host, port, secure } = window.Rune.Carrot.config.sage
  const protocol = secure !== false ? 'https' : 'http'
  const portSuffix = port ? `:${port}` : ''
  return `${protocol}://${host}${portSuffix}`
}

/**
 * Call the Sage API, with authentication handling
 * @param {object} axiosOptions - the options to pass to axios
 * @param {string} method - the method to use for the call, e.g. GET, POST, PATCH, DELETE
 * @param {object} params - the parameters to pass to the call
 * @param {string} path - the API path (e.g. /api/v1/{patient_id}/snapshots)
 *
 * @returns {Promise<*>} the response from the API call
 */
export const callSageApi = ({ path, params, axiosOptions, method }) =>
  callApi({
    axiosOptions,
    getAuthHeaders,
    method,
    params,
    url: `${getBaseUrl()}${path}`,
  })
